export default __webpack_public_path__ + "static/media/clear.inline.f4656281.svg";